export function SegmentSeparator () {
  return (
    <span className='text-gray-500 leading-[1.375rem] p-0.5' aria-hidden>
      /
    </span>
  )
}
